import { BiPalette, BiVizSpec, BiVizType } from '@euler/model/bi/viz';

/**
 * A viz as an export draws it in the palette picked for it (the backend's
 * `biPdfVizInPalette`). The dashboard's own palette draws it as on
 * screen; another is the whole document's: every card takes it, its own
 * palette and its series and KPI colors set aside.
 */
export function biVizInPalette(
  viz: BiVizSpec,
  picked: BiPalette,
  dashboardPalette: BiPalette,
): BiVizSpec {
  if (picked === dashboardPalette) return viz;
  const style = viz.style
    ? { ...viz.style, palette: undefined, seriesColors: undefined }
    : undefined;
  const plain = { ...viz, style } as BiVizSpec;
  if (plain.type === BiVizType.KpiGroup)
    return {
      ...plain,
      items: plain.items.map(item => ({ ...item, color: undefined })),
    };
  return plain;
}
